// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/images/profile-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/png/Wallet-Card.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-main-wrapper {
  padding-top: 50px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  background-attachment: fixed;
  height: 90vh;
}

.dashboard-main-wrap {
  margin-left: 240px;
  margin-top: 90px;
  display: flex;
  gap: 54px;
}


.dashboard-card {
  width: 310px;
  height: 194px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-size: 90% 50%;
  background-position: bottom;
  background-repeat: no-repeat;
  border: 3px solid #00A19B;
  border-radius: 19px;
  cursor: pointer;
  background-color: #fff !important;
}



.nact-card-logo-wrap{
  padding: 26px;
}

.nact-card-logo-wrap img{
  width: 113px;
}

.dashboard-card h3,
.dashboard-card-2 h3 {
  font-size: 25px;
  color: #a1cfcd;
  text-align: left;
  padding-top: 26px;
  padding-left: 26px;
}

.dashboard-card span {
  color: #fbc425;
}

.dashboard-card-2 span {
  color: #136b67;
}

.card-blur {
  opacity: 0.5 !important;
}

.dashboard-card:hover,
.dashboard-card-2:hover {
  opacity: 100% !important;
}
`, "",{"version":3,"sources":["webpack://./src/Dashboard/Dashboard.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,yDAAwD;EACxD,qCAAqC;EACrC,uCAAuC;EACvC,4BAA4B;EAC5B,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,YAAY;EACZ,aAAa;EACb,yDAAsD;EACtD,wBAAwB;EACxB,2BAA2B;EAC3B,4BAA4B;EAC5B,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,iCAAiC;AACnC;;;;AAIA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B","sourcesContent":[".dashboard-main-wrapper {\n  padding-top: 50px;\n  background-image: url(\"../assets/images/profile-bg.png\");\n  background-size: 100% 100% !important;\n  background-repeat: no-repeat !important;\n  background-attachment: fixed;\n  height: 90vh;\n}\n\n.dashboard-main-wrap {\n  margin-left: 240px;\n  margin-top: 90px;\n  display: flex;\n  gap: 54px;\n}\n\n\n.dashboard-card {\n  width: 310px;\n  height: 194px;\n  background-image: url(\"../assets/png/Wallet-Card.png\");\n  background-size: 90% 50%;\n  background-position: bottom;\n  background-repeat: no-repeat;\n  border: 3px solid #00A19B;\n  border-radius: 19px;\n  cursor: pointer;\n  background-color: #fff !important;\n}\n\n\n\n.nact-card-logo-wrap{\n  padding: 26px;\n}\n\n.nact-card-logo-wrap img{\n  width: 113px;\n}\n\n.dashboard-card h3,\n.dashboard-card-2 h3 {\n  font-size: 25px;\n  color: #a1cfcd;\n  text-align: left;\n  padding-top: 26px;\n  padding-left: 26px;\n}\n\n.dashboard-card span {\n  color: #fbc425;\n}\n\n.dashboard-card-2 span {\n  color: #136b67;\n}\n\n.card-blur {\n  opacity: 0.5 !important;\n}\n\n.dashboard-card:hover,\n.dashboard-card-2:hover {\n  opacity: 100% !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
